import Dashboard from '@material-ui/icons/Dashboard';
import MapaLeito from 'views/MapaLeito/MapaLeito';
import Relatorio from 'views/Relatorio/Relatorio';
import Login from 'views/Login/Login';

const dashboardRoutes = [
  {
    path: '/mapaLeito',
    name: 'Mapa de Leitos',
    icon: Dashboard,
    component: MapaLeito,
    layout: '/admin',
  },
  {
    path: '/relatorio',
    name: 'Relatório',
    icon: Dashboard,
    component: Relatorio,
    layout: '/admin',
    requirePermissao: true,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    layout: '/auth',
  },
];

export default dashboardRoutes;
